import angular from 'angular';

import '../../../../services/orders';
import './customer-order-detail-line';

angular.module('folkeuni').component('customerOrderDetails', {
  bindings: {
    guid: '=',
    orderId: '='
  },
  templateUrl: '/shop-dist/templates/customer-order-details.html?c=' + window.cacheBurst,
  transclude: false,
  controller: function(Orders, $timeout) {
    var $ctrl = this;
    $ctrl.order = null;

    $ctrl.backToList = function(){
      console.log("backToList");
      $ctrl.guid = null;
      $ctrl.id = null;
    }
    
    $ctrl.order = []

    $ctrl.$onInit = function() {
      Orders.getOrderByIdAndGuid($ctrl.orderId,$ctrl.guid).then(function(orderObj) {
        $ctrl.order = orderObj;
      }, function(errorResponse) {

        console.log(errorResponse);
      });
    }
  }
});
